export default "__VITE_ASSET__B$l4YfJG__"